/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.queue.routeReports'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  startReportId: /*#__PURE__*/ l.integer(),
  endReportId: /*#__PURE__*/ l.integer(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  assigned: /*#__PURE__*/ l.integer(),
  unmatched: /*#__PURE__*/ l.integer(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Route reports within an ID range to matching queues based. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'OutOfRange',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
